export default {
  getUserMetrics(state) {
    return state.userMetrics;
  },
  getResponseCode(state) {
    return state.responseCode;
  },
};
